import { useState, useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import classnames from 'classnames/bind'

// Libs
import useMedia from '@/hooks/useMedia'

// Components
import Insight from '@/components/shared/Insight'

import { ROOM_LIVE_TYPE } from '@/constants/liveRoom'

import styles from './style.module.scss'

const cx = classnames.bind(styles)

type CountdownProps = {
  targetDate: Date
  isFuture: boolean
  roomId: string
  liveSourceType: number
}

type TimeLeft = {
  hours: number
  minutes: number
  seconds: number
}

const DEFAULT_TIME_LEFT: TimeLeft = {
  hours: 0,
  minutes: 0,
  seconds: 0,
}

const calculateTimeLeft = (targetDate: Date): TimeLeft => {
  const difference = +targetDate - +new Date()
  let timeLeft: TimeLeft = DEFAULT_TIME_LEFT

  if (difference > 0) {
    timeLeft = {
      hours: Math.floor(difference / (1000 * 60 * 60)),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    }
  }

  return timeLeft
}

const formatTime = (time: number) => {
  return String(time).padStart(2, '0')
}

const SaleEndCountdown = ({ targetDate, isFuture, roomId, liveSourceType }: CountdownProps) => {
  const { t } = useTranslation()
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(DEFAULT_TIME_LEFT)

  const { isDesktop } = useMedia()

  useEffect(() => {
    setTimeLeft(calculateTimeLeft(targetDate))

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate))
    }, 1000)

    return () => clearInterval(timer)
  }, [targetDate])

  const hours = formatTime(timeLeft.hours)
  const minutes = formatTime(timeLeft.minutes)
  const seconds = formatTime(timeLeft.seconds)

  return (
    <div className={styles.countdown}>
      {!isFuture && (
        <Insight
          className={cx('countdown-insight')}
          roomId={roomId}
          liveSourceType={liveSourceType}
          liveType={ROOM_LIVE_TYPE.CURRENT}
          status={isDesktop ? 'live' : 'empty'}
          theme='transparent-black'
          // gtmClickLiveRoomPosition={GtmClickLiveRoomPosition.ITEM_CARD}
        />
      )}
      <span className={styles.label}>{isFuture ? t('LiveDealsSection_SaleStartCountdown_Label') : t('LiveDealsSection_SaleEndCountdown_Label')}</span>
      <div className={styles.digits}>
        <div className={styles.digitBlock}>{hours}</div>
        <span className={styles.separator}>:</span>
        <div className={styles.digitBlock}>{minutes}</div>
        <span className={styles.separator}>:</span>
        <div className={styles.digitBlock}>{seconds}</div>
      </div>
    </div>
  )
}

export default SaleEndCountdown
